import React, {useEffect, useState} from "react";
import {initAnalytics, setAnalyticsConsent, trackPageview, getAnalyticsConsent} from "../utils/analytics";

function CookieBanner() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (typeof window === "undefined") return;
        const consent = getAnalyticsConsent();
        if (!consent) setVisible(true);
    }, []);

    const accept = async () => {
        setAnalyticsConsent("granted");
        setVisible(false);
        await initAnalytics();
        trackPageview(window.location.pathname, document.title);
    };

    const decline = () => {
        setAnalyticsConsent("denied");
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div className="cookie-banner" role="region" aria-label="Cookies">
            <p>
                Nous utilisons des cookies analytiques pour améliorer l’expérience.{" "}
                <a href="/protection-data">En savoir plus</a>.
            </p>
            <div className="cookie-actions">
                <button type="button" className="cookie-accept" onClick={accept}>
                    Accepter
                </button>
                <button type="button" className="cookie-decline" onClick={decline}>
                    Refuser
                </button>
            </div>
        </div>
    );
}

export default CookieBanner;
